import React from "react";

import { useI18NContext } from "@/features/common/components/i18n/I18NProvider";

interface CommentTimeProps {
  time: Date;
}
export const CommentTime: React.FC<CommentTimeProps> = (props) => {
  const { time } = props;
  const { formatDistanceToNowStrictWithLocale, ready } = useI18NContext();

  if (!ready) return null;

  return (
    <span className="text-sm text-gray-500 whitespace-nowrap">
      {formatDistanceToNowStrictWithLocale({
        date: time,
      })}
    </span>
  );
};
